document.addEventListener('DOMContentLoaded', function() {  
  const CLOSE_TAB = "close-tab";
  const CLOSING_TAB = "closing-tab";
  const DISPLAY_TAB = "display-tab";
  const SLIDE_LEFT = "slide-left";
  const CLOSED_TAB = "closed-tab";
  const POSITIONING_TAB = "positioning-tab";
  const END_TRANSITION = "endtabtransition";
  let transitioning = false;

  const dispatchEndTransition = element => element.dispatchEvent(new Event(END_TRANSITION));

  const isOpened = element => element.classList.contains(DISPLAY_TAB);

  const waitTransition = (callback, content, wait = true) => {
    if (!wait) {
      callback();
      return;
    }

    let handlerCalled = false;

    const handleEndTransition = event => {
      if (event.target !== content) {
        return;
      }

      handlerCalled = true;
      content.removeEventListener(END_TRANSITION, handleEndTransition);
      callback();
    };

    content.addEventListener(END_TRANSITION, handleEndTransition);

    setTimeout(() => {
      if (!handlerCalled) {
        dispatchEndTransition(content);
      }
    }, 100);
  };

  const toggleAriaAndClasses = (content, isOpen) => {
    if (!content) {
      return;
    }

    const button = document.querySelector(`[data-target="${content.id}"]`);

    button.classList.toggle(CLOSED_TAB, !isOpen);
    button.setAttribute("aria-expanded", isOpen);
    content.setAttribute("aria-hidden", !isOpen);
  };

  const showTab = content => {
    if (transitioning || isOpened(content)) {
      return;
    }

    content.classList.remove(CLOSE_TAB);
    content.classList.add(CLOSING_TAB);
    content.classList.add(POSITIONING_TAB);

    toggleAriaAndClasses(content, true);

    transitioning = true;

    const complete = () => {
      transitioning = false;
      content.classList.remove(CLOSING_TAB);
      content.classList.add(SLIDE_LEFT, CLOSE_TAB, DISPLAY_TAB);
      content.classList.remove(POSITIONING_TAB);
    };

    waitTransition(complete, content, true);
  };

  const handleClosingTab = (button, content) => {
    if (transitioning) {
      return;
    }

    const nav = button.closest(".tab-selection__nav");
    const buttons = Array.from(nav.querySelectorAll(".tab-selection__nav-btn"));
    const openedButton = buttons.find(btn => btn.ariaExpanded === "true");
    const currentContainer = openedButton.closest(".tab-selection");
    const openedContent = currentContainer.querySelector(`#${openedButton.dataset.target}`);

    openedContent.classList.add(CLOSING_TAB);
    openedContent.classList.remove(CLOSE_TAB, DISPLAY_TAB);

    const complete = () => {
      transitioning = false;
      showTab(content);
      openedContent.classList.remove(SLIDE_LEFT);
      openedContent.classList.add(CLOSE_TAB);
      openedContent.classList.remove(CLOSING_TAB);
      toggleAriaAndClasses(openedContent, false);
    };

    waitTransition(complete, openedContent, true);
  };

  const onTabClick = event => {
    const currentButton = event.currentTarget;
    const currentContainer = currentButton.closest(".tab-selection");
    const currentContent = currentContainer.querySelector(`#${currentButton.dataset.target}`);

    if (!isOpened(currentContent)) {
      handleClosingTab(currentButton, currentContent);
    }
  };

  const initiateTabOpen = () => {
    const tabNavContainers = Array.from(document.querySelectorAll(".tab-selection__nav"));

    if (tabNavContainers.length < 1) {
      return;
    }

    tabNavContainers.forEach(tabNavContainer => {
      const tabs = Array.from(tabNavContainer.querySelectorAll(".tab-selection__nav-btn"));
      const currentContainer = tabNavContainer.closest(".tab-selection");
      const isSlider = currentContainer.querySelector(".slider-container");

      if (tabs.length < 1) {
        return;
      }

      if (!isSlider) {
        // addHeightToTabsContainer(currentContainer, "options", false);
      }

      tabs.forEach(tab => tab.addEventListener("click", onTabClick));
    });
  };

  initiateTabOpen();
});